import { Box, Typography } from '@mui/material';
import noDataImage from '../../../../../../../assets/images/no_data.png';

export const ChartError = ({ error }: { error: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
      }}
    >
      <img height={80} width={80} src={noDataImage} alt="No data" />

      <Typography fontSize={'0.875rem'} fontWeight={500} color="text.secondary">
        {error}
      </Typography>
    </Box>
  );
};
